import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Switch, Spin, Image, Pagination, ConfigProvider, Button, Segmented, Space, message, Modal, Popover } from 'antd';
import { CheckOutlined, LeftOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import API, { commonApiInvoker } from '@api/api';
import Utils from "@utils/utils"
import PSAIModal from "@PSAIComponents/PSAIModal";
import PictureViewer from "@view/compoents/PictureViewer";
import Iconfont from '@/utils/Iconfont';

// 寄拍
function ShootItem (props) {
    const {item, onPickClick, onPreviewClick} = props
    const isPicked = useMemo(() => {
        return item.picked == 1 && item.marked == 0
    }, [item])
    const isMarked = useMemo(() => {
        return item.marked == 1
    }, [item])
    return (
        <div className={styles.shootItem} onClick={() => onPreviewClick(item)}>
        {
            isPicked ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{background: "#43C287", cursor: "not-allowed"}}>可用</span> :
            isMarked ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.marked}`} style={{background: "#43C287", cursor: "not-allowed"}}>已提交</span> :
            <span className={`${styles.pickTrigger} ${styles.visible}`}>标记为可用</span>
        } {
            <Image
                style={{background: "#CCCCCC"}}
                preview={false}
                src={item.displayImage + '?&x-oss-process=style/thumbnail-width-300'}
                fallback={require('@assets/images/fallback.png')}
                alt=""
            />
        } {
            <div className={styles.HoverMask} onClick={() => onPreviewClick(item)}>
                <Iconfont type="icon-larger" className={styles.PreviewIcon} />
                {!isMarked &&
                <button
                    className={`${styles.PassButton} ${isPicked ? styles.actived : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onPickClick(item)
                    }}
                >
                    可用
                </button>}
            </div>
        }
        </div>
    )
}

// AI制片
function ShootItemVirtual3 (props) {
    const {item, onPickClick, onPreviewClick} = props
    const isPicked = useMemo(() => {
        return item.picked == 1
    }, [item])
    const isUnPicked = useMemo(() => {
        return item.picked == 2
    }, [item])
    const isSubmit = useMemo(() => {
        return item.submitStatus == 1
    }, [item])
    const isRefined = useMemo(() => {
        return item.picked == 0 && !!item.refined
    }, [item])
    return (
        <div className={styles.shootItem} onClick={() => onPreviewClick(item)}>
        {
            <Image
                style={{background: "#CCCCCC"}}
                preview={false}
                src={item.displayImage + '?&x-oss-process=style/thumbnail-width-300'}
                fallback={require('@assets/images/fallback.png')}
                alt=""
            />
        } {
            isRefined ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{cursor: "not-allowed"}}>已修改</span> :
            (isPicked && !isSubmit) ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{background: "#43C287", cursor: "not-allowed"}}>可用</span> :
            (isUnPicked && !isSubmit) ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{background:"#FF8C3F", cursor: "not-allowed"}}>需修改</span> :
            (isPicked && isSubmit) ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{background: "#43C287", cursor: "not-allowed"}}>已提交可用</span> :
            (isUnPicked && isSubmit) ?
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{background:"#FF8C3F", cursor: "not-allowed"}}>已提交需修改</span> :
            <span className={`${styles.pickTrigger} ${styles.visible} ${styles.picked}`} style={{background: "#F2F3F5", color: "#878F99", cursor: "not-allowed"}}>未选中</span>
        } {
            <div className={styles.HoverMask} onClick={() => onPreviewClick(item)}>
                <Iconfont type="icon-larger" className={styles.PreviewIcon} />
                {(!isSubmit || isUnPicked) &&
                <button
                    className={`${styles.PassButton} ${isPicked ? styles.actived : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onPickClick(item)
                    }}
                >
                    可用
                </button>}
            </div>
        }
        </div>
    )
}

export default function ShootList(props) {
    const {shootListId, shootListName, shootListSkuId, shootListVersion, shootListVersionVirtual} = props
    const [skuList, setSkuList] = useState([])
    const [skuListAll, setSkuListAll] = useState([])
    const [submitSkuListAll, setSubmitSkuListAll] = useState([])
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [total, setTotal] = useState();
    const [isSpinning, setIsSpinning] = useState(false);
    const [segmentedValue, setSegmentedValue] = useState(0); // 0-全部图片 1-已标记 2-已选图
    const [force, updateForce] = useState(false);
    const [submittedCount, setSubmittedCount] = useState(0) // 已提交图片数量

    // 获取sku的图片列表
    const listPhotoBySku = useCallback(() => {
        if (!shootListId) return
        setIsSpinning(true)
        const data = {
            pageIndex: current,
            pageSize: pageSize,
            taskId: shootListId,
        }
        if (shootListVersionVirtual == 0) { // 寄拍
            if (segmentedValue == 1) { // 已标记可用
                data.marked = 0
                data.picked = 1
            } else if (segmentedValue == 2) { // 已提交
                data.marked = 1
            }
        } else if (shootListVersionVirtual == 3) { // AI制片
            if (segmentedValue == 1) { // 已标记可用
                data.submitStatus = 0
                data.picked = 1
            } else if (segmentedValue == 2) { // 已提交
                data.submitStatus = 1
            }
        }
        commonApiInvoker(API.listPhotoBySku(data)).then(res => {
            setSkuList([...res.items])
            setTotal(res.total)
        }).finally(() => {
            setIsSpinning(false)
        })
    }, [current, pageSize, segmentedValue, shootListId, shootListVersionVirtual])
    // 请求所有的sku，便于大图查看切换所有
    const listPhotoBySkuAllByFilter = useCallback(() => {
        if (!total) return
        if (!shootListId) return
        const data = {
            pageIndex: 1,
            pageSize: total,
            taskId: shootListId,
        }
        if (shootListVersionVirtual == 0) { // 寄拍
            if (segmentedValue == 1) { // 已标记可用
                data.marked = 0
                data.picked = 1
            } else if (segmentedValue == 2) { // 已提交
                data.marked = 1
            }
        } else if (shootListVersionVirtual == 3) { // AI制片
            if (segmentedValue == 1) { // 已标记可用
                data.submitStatus = 0
                data.picked = 1
            } else if (segmentedValue == 2) { // 已提交
                data.submitStatus = 1
            }
        }
        commonApiInvoker(API.listPhotoBySku(data)).then(res => {
            setSkuListAll([...res.items])
        })
    }, [total, segmentedValue, shootListId, shootListVersionVirtual])
    // 请求所有的sku，以便获取已提交数量
    const listPhotoBySkuAllForSubmitCount = useCallback(() => {
        if (!shootListId) return
        const data = { pageIndex: 1, pageSize: 1, taskId: shootListId }
        commonApiInvoker(API.listPhotoBySku(data)).then(res => {
            const summaryTotal = res.total || 0
            if (!summaryTotal) {
                setSubmitSkuListAll([])
                setSubmittedCount(0)
                return
            }
            return commonApiInvoker(API.listPhotoBySku({
                pageIndex: 1,
                pageSize: summaryTotal,
                taskId: shootListId,
            })).then(summaryRes => {
                const items = summaryRes.items || []
                setSubmitSkuListAll(items)
                if (shootListVersionVirtual == 0) {
                    setSubmittedCount(items.filter(item => item.marked == 1).length)
                } else {
                    setSubmittedCount(items.filter(item => item.submitStatus == 1).length)
                }
            })
        })
    }, [shootListId, shootListVersionVirtual])
    // 分页数据
    useEffect(() => {
        listPhotoBySku()
    }, [listPhotoBySku, force])
    // 请求所有的sku，便于大图查看切换所有
    useEffect(() => {
        listPhotoBySkuAllByFilter()
    }, [listPhotoBySkuAllByFilter, force])
    // 请求所有的sku，以便获取已提交数量
    useEffect(() => {
        listPhotoBySkuAllForSubmitCount()
    }, [listPhotoBySkuAllForSubmitCount, force])
    useEffect(() => {
        setCurrent(1)
    }, [pageSize])
    // 修改pagesize
    const onShowSizeChange = useCallback((current, pageSize) => {
        setCurrent(current);
        setPageSize(pageSize)
    }, [])
    // 标记是否可用
    const pickClick = useCallback((item) => {
        const picked = item.picked == 1
        const id = item.id
        commonApiInvoker(API.markPhoto({
            id: id,
            picked: picked ? 0 : 1, // 1可用2不可用
        })).then(res => {
            updateForce({})
        })
    }, [])
    // AI制片查看大图
    const [pictureViewOpen, setPictureViewOpen] = useState(false)
    const [pictureViewData, setPictureViewData] = useState([])
    const [pictureViewDefaultIndex, setPictureViewDefaultIndex] = useState(0)
    const preViewClickVirtual3 = useCallback((item, index) => {
        setPictureViewDefaultIndex((current - 1) * pageSize + index)
        setPictureViewData(skuListAll.map(item => {
            const picked = item.picked
            const marked = item.marked
            const refined = item.refined
            const status = picked === 2 ? 'rejected' :
                        picked === 1 ? 'approved' :
                        shootListVersionVirtual == 0 ? null : // 寄拍不显示已修改
                        ((refined && picked === 0) ? 'modified' : null) // AI制片显示已修改
            // 寄拍已提交图片保持只读；AI 制片已提交需修改图片允许改为可用
            const readOnly = marked === 1 && picked === 1
            const extraImages = []
            const refImages = item.algoAttr?.refImages || []
            if (refImages.length > 0) extraImages.push(...refImages.map(item => ({ label: '参考图', url: item.url })))
            else if (item.algoAttr?.refImage) extraImages.push({ label: '参考图', url: item.algoAttr?.refImage })
            if (item.algoAttr?.inputImage) extraImages.push({ label: '商品图', url: item.algoAttr?.inputImage })
            const matchImages = item.algoAttr?.matchImages || []
            if (matchImages.length > 0) extraImages.push(...matchImages.map(item => ({ label: '搭配图', url: item.url })))
            else if (item.algoAttr?.matchClothImage) extraImages.push({ label: '搭配图', url: item.algoAttr?.matchClothImage })
            return {
                id: item.id,
                url: item.displayImage, // 主图地址
                status: status, // 'approved' | 'rejected' | 'modified' | 'default'
                annotations: item.annotations, // 评论列表
                annotationHistory: [
                    ...item.annotationHistory.sort((a, b) => a.createdTime < b.createdTime ? 1 : -1).map(item => item.userAnnotations?.length ? item.userAnnotations : [])
                ].sort((a, b) => {
                    const timestampA = a[0]?.timestamp || 0
                    const timestampB = b[0]?.timestamp || 0
                    return timestampB - timestampA
                }), // 评论历史
                title: shootListName,
                readOnly: readOnly,
                shouldCommitOnLeave: false,
                rejectDisabled: shootListVersionVirtual == 0, // 0寄拍1普通3AI制片
                cancelDisabled: true,

                extraInfos: [{
                    label: '批次',
                    value: shootListVersion,
                }],
                extraImages: extraImages,
                _raw: item,
            }
        }))
        setPictureViewOpen(true)
    }, [skuListAll, shootListName, shootListVersion, current, pageSize, shootListVersionVirtual])
    const handleStatusChange = useCallback(async ({id, status, annotation}, rawItem) => {
        const picked = status === 'approved' ? 1 : status === 'rejected' ? 2 : 0
        await commonApiInvoker(API.markPhoto({
            id: id,
            picked: picked, // 0-默认1可用2不可用
            annotations: annotation,
        }), false, true)
        updateForce({})
    }, [])
    const onPreviewClose = useCallback(async () => {
        try {
            if (!shootListId) return
            // 获取所有sku的图片列表
            if (!shootListId) return
            const data = { pageIndex: 1, pageSize: 1, taskId: shootListId }
            const res = await commonApiInvoker(API.listPhotoBySku(data))
            const total = res.total
            const data2 = { pageIndex: 1, pageSize: total, taskId: shootListId }
            const res2 = await commonApiInvoker(API.listPhotoBySku(data2))
            const skuListAll = [...res2.items]
            // 统计可用图片数量
            let approvedCount = 0, rejectedCount = 0
            if (shootListVersionVirtual == 0) {
                approvedCount = skuListAll.filter(item => item.picked === 1 && item.marked === 0).length
            } else {
                approvedCount = skuListAll.filter(item => item.picked === 1 && item.submitStatus === 0).length
                rejectedCount = skuListAll.filter(item => item.picked === 2 && item.submitStatus === 0).length
            }
            if (approvedCount === 0 && rejectedCount === 0) return
            const confirmRes = await submitConfirm(approvedCount, rejectedCount, shootListVersionVirtual)
            if (!confirmRes) return
            await commonApiInvoker(API.submitPhoto({
                taskId: shootListId,
            }), false, true)
            props.goBack()
            message.success("选图提交成功")
        } catch (err) {
            console.error(err)
        } finally {
            setPictureViewOpen(false)
        }
    }, [shootListId, shootListVersionVirtual])
    // 提交反馈
    const handleSubmit = useCallback(async () => {
        // 获取所有sku的图片列表
        if (!shootListId) return
        const data = { pageIndex: 1, pageSize: 1, taskId: shootListId }
        const res = await commonApiInvoker(API.listPhotoBySku(data))
        const total = res.total
        const data2 = { pageIndex: 1, pageSize: total, taskId: shootListId }
        const res2 = await commonApiInvoker(API.listPhotoBySku(data2))
        const skuListAll = [...res2.items]
        // 统计可用图片数量
        let approvedCount = 0, rejectedCount = 0
        if (shootListVersionVirtual == 0) {
            approvedCount = skuListAll.filter(item => item.picked === 1 && item.marked === 0).length
        } else {
            approvedCount = skuListAll.filter(item => item.picked === 1 && item.submitStatus === 0).length
            rejectedCount = skuListAll.filter(item => item.picked === 2 && item.submitStatus === 0).length
        }
        const confirmRes = await submitConfirm(approvedCount, rejectedCount, shootListVersionVirtual)
        if (!confirmRes) return
        await commonApiInvoker(API.submitPhoto({
            taskId: shootListId,
        }), false, true)
        props.goBack()
        message.success("选图提交成功")
    }, [shootListId, shootListVersionVirtual, total])
    const submitButtonStatus = useMemo(() => {
        const hasPendingApproved = shootListVersionVirtual == 0 ?
            submitSkuListAll.some(item => item.picked == 1 && item.marked == 0) :
            submitSkuListAll.some(item => (item.picked == 1 || item.picked == 2) && item.submitStatus == 0)
        if (hasPendingApproved) return 'enabled'
        const hasSubmittedImages = shootListVersionVirtual == 0 ?
            submitSkuListAll.some(item => item.marked == 1) :
            submitSkuListAll.some(item => item.submitStatus == 1)
        if (hasSubmittedImages) return 'submitted'
        return 'disabled'
    }, [shootListVersionVirtual, submitSkuListAll])
    const submitButtonNode = useMemo(() => {
        if (submitButtonStatus == 'submitted') {
            return (
                <button className={styles.btn} style={{width: 144}} disabled>
                    <CheckOutlined style={{fontSize:16}} />已提交
                </button>
            )
        }
        if (submitButtonStatus == 'enabled') {
            return (
                <button className={`${styles.btn} ${styles.Primary}`} style={{width: 144}} onClick={handleSubmit}>
                    <Iconfont type="icon-delivery-submit" style={{fontSize:16}} />提交反馈
                </button>
            )
        }
        return (
            <Popover
                content={<span>请先标记可用或需修改的图片</span>}
                placement='bottom'
                arrow={false}
            >
                <button className={styles.btn} style={{width: 144}} disabled>
                    <Iconfont type="icon-delivery-submit" style={{fontSize:16}} />提交反馈
                </button>
            </Popover>
        )
    }, [submitButtonStatus, handleSubmit])
    // 切换选项
    const handleSegmentedChange = useCallback((value) => {
        setSegmentedValue(value)
        setCurrent(1)
    }, [])

    return (
        <div className={styles.masterShootBox}>
            <div className={styles.topBox}>
                <div className={styles.LeftBox}>
                    <Button className={styles.GoBack} icon={<LeftOutlined />} onClick={() => props.goBack()}>返回</Button>
                    <span className={styles.SkuName}>{shootListName}</span>
                    <span className={styles.SubmitTips}>（已提交{submittedCount}张）</span>
                </div>
                <ConfigProvider
                    theme={{
                        components: {
                            Segmented: {
                                /* 这里是你的组件 token */
                                trackBg: "#EFF2FD",
                            },
                        },
                    }}
                >
                    <Segmented
                        options={[{
                            label: '全部图片',
                            value: 0
                        }, {
                            label: '已标记可用',
                            value: 1
                        }, {
                            label: '已提交',
                            value: 2
                        }]}
                        onChange={handleSegmentedChange}
                    />
                </ConfigProvider>
                {submitButtonNode}
            </div>
            <Spin spinning={isSpinning}>
                <div className={`${styles.shootListScroll} _beauty_scrollbar`}>
                    <div className={styles.shootList}>
                    {
                        skuList.map((item, index) => (
                            shootListVersionVirtual == 0 ?
                            <ShootItem
                                key={item.id}
                                item={item}
                                onPickClick={pickClick}
                                onPreviewClick={item => preViewClickVirtual3(item, index)}
                            /> :
                            <ShootItemVirtual3
                                key={item.id}
                                item={item}
                                onPickClick={pickClick}
                                onPreviewClick={item => preViewClickVirtual3(item, index)}
                            />
                        ))
                    }
                    </div>
                </div>
            </Spin>
            <Pagination
                // size='small'
                current={current}
                pageSize={pageSize}
                total={total}
                onChange={setCurrent}
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
            />
            <Modal
                open={pictureViewOpen}
                footer={null}
                mask={{closable: false}}
                keyboard={false}
                focusable={{trap: false}}
                closeIcon={false}
                destroyOnHidden
                width="100vw"
                style={{ top: 0, maxWidth: '100vw'}}
                styles={{
                    wrapper: { overflow: "hidden" },
                    container: {padding: 0, borderRadius: 0},
                    content: { padding: 0, borderRadius: 0 },
                    body: { height: "100vh", overflow: "hidden", padding: 0 }
                }}
                onCancel={onPreviewClose}
            >
                <PictureViewer
                    defaultIndex={pictureViewDefaultIndex}
                    defaultImages={pictureViewData}
                    submitOnSwitch
                    submitEmptyStatusOnLeave
                    requireRejectedAnnotationBeforeSwitch
                    canvasToolsDisabled={true} // 禁用画布工具
                    onCancel={onPreviewClose}
                    onStatusChange={handleStatusChange}
                />
            </Modal>
        </div>
    );
}

function submitConfirm(approvedCount, rejectedCount, shootListVersionVirtual) {
    return new Promise((resolve, reject) => {
        PSAIModal.confirm({
            width: 420,
            content: (
                <div className={styles.SubmitModal}>
                    <div>
                        点击<strong>提交反馈</strong>将进入后续流程
                    </div>
                    <div className={styles.SubmitTipsContent}>
                        <div>
                            <span>可用图片数量</span>
                            <span style={{color: "#43C287"}}>{approvedCount}张</span>
                        </div>
                        {shootListVersionVirtual == 0 ? null : 
                        <div>
                            <span>需修改图片数量</span>
                            <span style={{color: "#FF8C3F"}}>{rejectedCount}张</span>
                        </div>}
                    </div>
                    <ul className={styles.SubmitTipsList}>
                        <li>标记“可用”代表选中该图且无需修改</li>
                        {shootListVersionVirtual == 0 ? null : <li>标记“需要修改”将对图片进行微调</li>}
                        <li>未标记的图片将视为放弃</li>
                    </ul>
                    <div className={styles.SubmitTipsDesc}>
                        提交后图片状态将无法修改，但仍可追加选图
                    </div>
                </div>
            ),
            okText: '提交反馈',
            cancelText: '暂不提交',
            onOk () {
                resolve(true)
            },
            onCancel () {
                resolve(false)
            }
        })
    })
}
